import { Map, List } from "immutable";

import { UserRecord } from "records";

import { STATE_STATUS, USER_ACTIONS } from "constants";

const INTIAL_STATE = new Map({
    data: null,
    permissions: new Map({}),
    permissionsStatus: STATE_STATUS.UNFETCHED,
    status: STATE_STATUS.UNFETCHED
});

export default (state = INTIAL_STATE, { type, payload, error }) => {
    switch (type) {
    case USER_ACTIONS.FETCH_USER:
        return state.set("status", STATE_STATUS.FETCHING);
    case USER_ACTIONS.FETCHED_USER: {
        return state
            .set("status", STATE_STATUS.FETCHED)
            .set("data", new UserRecord(payload.user));
    }
    case USER_ACTIONS.FAILED_FETCH_USER:
        return state.set("status", STATE_STATUS.FETCH_FAILED);
    case USER_ACTIONS.FETCH_USER_PERMISSIONS:
        return state.set("permissionsStatus", STATE_STATUS.FETCHING);
    case USER_ACTIONS.FETCHED_USER_PERMISSIONS: {
        let groups = state.get("data").groups.map(_ => _.name);
        const isDistributorRM = groups.find(_ => _ === "Distributor RM");
        if(isDistributorRM) {
            groups = groups.filter(function(item) {
                if (item === "Distributor RM" || item === "Distributor Scheme View Group" || item === "Distributor Scheme Creation Group" || item === "DBT Admin" || item === "DBT"){
                    return true;
                }
                return false;
            });
        }
        const permissionsMap = new List(
            payload.permissions
                .filter(_ => groups.includes(Object.keys(_)[0]))
                .map(_ => _[Object.keys(_)[0]])
                .reduce((agg, _) => [...agg, ..._], [])
        )
            .toMap()
            .mapEntries(([, v]) => [v, true]);
        return state
            .set("permissionsStatus", STATE_STATUS.FETCHED)
            .set("permissions", permissionsMap);
    }
    case USER_ACTIONS.FAILED_USER_PERMISSIONS:
        return state
            .set("permissionsStatus", STATE_STATUS.FETCH_FAILED)
            .set("permissionsError", error);
    case "LOGOUT":
        return INTIAL_STATE;
    default:
        return state;
    }
};
